export function DownloadFile({
  data,
  filename,
  className,
  title,
}: {
  data: Record<string, unknown> | string;
  filename: string;
  className?: string;
  title: string;
}) {
  const getDataString = () => {
    if (typeof data === "string") {
      return data;
    }
    return JSON.stringify(data, null, 2);
  };

  const getMimeType = () => {
    const extension = filename.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "json":
        return "data:application/json,";
      case "tsv":
        return "data:text/tab-separated-values,";
      default:
        return "data:application/octet-stream,";
    }
  };

  const blob = new Blob([getDataString()], { type: getMimeType() });
  const href = URL.createObjectURL(blob);

  return (
    <a className={className} download={filename} href={href}>
      {title}
    </a>
  );
}
